module.exports = __webpack_public_path__ + "static/media/RIST-logo_02.59d2ff1c.png";